<template>
  <div>
    <ul class="nav">
      <li class="nav-item" @click="toggleShowModalAdd()">
        <a class="nav-link" href="#">
          <img src="#" alt="">
          Add phone number
        </a>
      </li>
    </ul>
    <Modal
      v-show="showModalAdd"
      :scrollable="true"
      :bodyId="''"
      :modalClass="'add-phone-numbers'"
      :headerId="''"
      @close="toggleShowModalAdd"
    >
      <template #header>
        <h4>{{ getLocalization('Import phone numbers') }}</h4>
      </template>
      <template #body>
        <div class="container">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <form @submit.prevent="uploadCSV" enctype="multipart/form-data">
                <div class="form-group">
                  <label for="csvFile" class="label mb-3">Load a CSV file</label>
                  <div class="custom-file">
                    <input type="file" id="csvFile" accept=".csv" ref="fileInput" name="file" class="custom-file-input"/>
                  </div>
                </div>
                <button type="submit" class="btn btn-success mt-3">{{ getLocalization('Add phones') }}</button>
              </form>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '../../../components/table/modal.vue';
import BaseSendRequestMixin from "../../../components/mixins/BaseSendRequestMixin.vue";
import BaseLoaderMixin from "../../../components/mixins/BaseLoaderMixin.vue";
import BaseMessagingMixin from "../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import CustomPagination from "../../../components/table/pagination/customPagination.vue";

export default {
  name: "userPhoneNumber",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin,
    BaseLoaderMixin
  ],
  components: {
    Modal,
    BaseTable,
    CustomPagination
  },
  data: function () {
    return {
      showModalAdd: false,
    }
  },
  methods: {
    toggleShowModalAdd() {
      this.showModalAdd = !this.showModalAdd;
    },
    async uploadCSV() {
      const file = this.$refs.fileInput.files[0];
      if (file) {
        let response = await this.sendRequest('/cabinet/partner/addPhones', 'post', {csvFile: file}, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (response['status'] == 'ok') {
          await this.alertMessage(response['message']);
          this.toggleShowModalAdd();
          this.$refs.fileInput.value = null;
          // this.$set(this.$refs.documentDocument, 'filename', null);
        }
        if(response['status'] == 'failed') {
          await this.alertMessage(response['message'],'error');
          this.$refs.fileInput.value = null;
        }
      } else {
        await this.alertMessage(this.getLocalization('Please load a file'), 'error');
      }
    }
  }
}
</script>
<style>
.add-phone-numbers {
  z-index: 9999;
}

.add-phone-numbers-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}

.add-phone-numbers-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 500px;
  margin: 7.75rem auto;
  padding: 20px 30px;
  border-radius: 5px;
  color: #000;
  background-color: #2D916F;
  box-sizing: border-box;
  transform: translate(0, 0);
}

.add-phone-numbers-header, .add-phone-numbers-body {
  display: flex;
  justify-content: center;
  background-color: #2D916F !important;
}

.add-phone-numbers-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  background-color: #2D916F !important;
}
.custom-file-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>
